import api from '@/api'
import {
  SET_MESSAGE_LIST_INFO,
  SET_MESSAGE_LIST_LOADING,
  SET_MESSAGE_PUSH_PARAMS,
} from './mutation-types'

const initMessageListInfo = {
  pageCount: 1,
  pageNum: 1,
  total: 0,
  size: 50,
  items: [],
}

const state = {
  loadingMessage: false,
  params: {
    pageNum: 1,
    pageSize: 50,
    messageStatus: '',
    messageCategory: '',
  },
  messageListInfo: { ...initMessageListInfo },
}

const mutations = {
  [SET_MESSAGE_LIST_INFO](state, payload) {
    state.messageListInfo = payload
  },
  [SET_MESSAGE_LIST_LOADING](state, payload) {
    state.loadingMessage = payload
  },
  [SET_MESSAGE_PUSH_PARAMS](state, { key, value }) {
    state.params[key] = value
  },
}

const actions = {
  // 增加短信模板
  async getMessagePage({ commit, state }) {
    const { messageStatus, messageCategory, pageNum, pageSize } = state.params
    const params = { pageNum, pageSize }
    if (messageStatus !== '') {
      params.messageStatus = messageStatus
    }
    if (messageCategory !== '') {
      params.messageCategory = messageCategory
    }
    commit(SET_MESSAGE_LIST_LOADING, true)
    try {
      const { data, code } = await api.dataGraphApi.getMessagePage(params)
      commit(SET_MESSAGE_LIST_LOADING, false)
      commit(SET_MESSAGE_LIST_INFO, code === 200 ? data : { ...initMessageListInfo })
      return data
    } catch (e) {
      commit(SET_MESSAGE_LIST_LOADING, false)
      commit(SET_MESSAGE_LIST_INFO, { ...initMessageListInfo })
      return null
    }
  },
  async addMessage({ commit, dispatch }, payload) {
    const res = await api.dataGraphApi.addMessage(payload)
    if (res.code === 200) {
      dispatch('getMessagePage')
    }
    return res
  },
  async deleteMessage({ commit, dispatch }, payload) {
    const res = await api.dataGraphApi.deleteMessage({ id: payload })
    if (res.code === 200) {
      dispatch('getMessagePage')
    }
    return res
  },
  async resendMessage({ commit, dispatch }, payload) {
    const res = await api.dataGraphApi.resendMessage({ id: payload })
    if (res.code === 200) {
      dispatch('getMessagePage')
    }
    return res
  },
  async editSendTime({ commit, dispatch }, payload) {
    const res = await api.dataGraphApi.updateSendTime(payload)
    if (res.code === 200) {
      dispatch('getMessagePage')
    }
    return res
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
